import { GameContainer } from "./game-container";
import { Vector3 } from "../math/vector3";
import { Matrix4x4 } from "../math/matrix4x4";

export class SimObject extends GameContainer {
}